.board {
  .trustpass-done {
    color: #fff;
    background: transparent;
    padding: 0;
  }
}
